<template>
  <ValidationProvider
    :ref="`vee-child-resolution-name-${itemId}`"
    v-slot="{ errors, classes }"
    :name="'input'"
    :rules="{ required: true, min_value: 1, max_value: maxInput }"
  >
    <b-form-input
      :key="key"
      v-model="position"
      :value="text"
      :type="inputType"
      :min="1"
      :max="maxInput"
      @blur="textAreaChanged(position)"
    ></b-form-input>
    <span class="invalid" :class="classes">{{ error }}</span>
  </ValidationProvider>
</template>

<script>
import { validate, extend } from "vee-validate";
export default {
  props: ["text", "property", "index", "itemId", "inputType", "maxInput"],
  data() {
    return {
      changedText: "",
      key: 0,
      error: null,
      position: null,
    };
  },
  watch: {
    text(newValue) {
      this.position = parseInt(newValue);
    },
  },
  created() {
    // console.log("this.data", this.data);
    this.position = parseInt(this.text);
  },
  methods: {
    async textAreaChanged(newValue) {
      // NOTE: We may do it on focus out
      if ((await this.validateInputs()) && newValue >= 1) {
        this.$emit("update", {
          value: newValue,
          property: this.property,
          index: this.index,
          itemId: this.itemId,
        });
      }
    },
    async validateInputs() {
      let self = this;
      var valid = true;
      await this.$refs["vee-child-resolution-name-" + this.itemId].validate().then(res => {
        console.log("res: ", res);
        if (!res.valid) {
          valid = false;
          self.error = res.errors[0];
        } else {
          self.error = "";
        }
      });
      // console.log("valid: ", valid);
      return valid;
    },
  },
};
</script>
